let ctx = null;
let lastHover = 0;

const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

export const playHover = () => {
  const now = Date.now();
  if (now - lastHover < 80) return; // throttle rapid hovers
  lastHover = now;
  try {
    const c = getCtx();
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.connect(gain);
    gain.connect(c.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(260, c.currentTime);
    osc.frequency.exponentialRampToValueAtTime(130, c.currentTime + 0.07);
    gain.gain.setValueAtTime(0.03, c.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.07);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + 0.08);
  } catch (_) {}
};

export const playClick = () => {
  try {
    const c = getCtx();
    const size = Math.floor(c.sampleRate * 0.07);
    const buf = c.createBuffer(1, size, c.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < size; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / size, 2.5);
    }
    const src = c.createBufferSource();
    src.buffer = buf;
    const filter = c.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = 200;
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.18, c.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.07);
    src.connect(filter);
    filter.connect(gain);
    gain.connect(c.destination);
    src.start(c.currentTime);
  } catch (_) {}
};

// Spider skitter — used for special events like voting
export const playSkitter = () => {
  try {
    const c = getCtx();
    for (let i = 0; i < 5; i++) {
      const delay = i * 0.018;
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.connect(gain);
      gain.connect(c.destination);
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(
        600 + Math.random() * 500,
        c.currentTime + delay
      );
      osc.frequency.exponentialRampToValueAtTime(
        150,
        c.currentTime + delay + 0.04
      );
      gain.gain.setValueAtTime(0.018, c.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(
        0.001,
        c.currentTime + delay + 0.04
      );
      osc.start(c.currentTime + delay);
      osc.stop(c.currentTime + delay + 0.05);
    }
  } catch (_) {}
};

export const initSounds = () => {
  const onOver = e => {
    if (e.target.closest('button, a, [role="button"]')) playHover();
  };
  const onClick = e => {
    if (e.target.closest('button, a, [role="button"]')) playClick();
  };
  document.addEventListener('mouseover', onOver);
  document.addEventListener('click', onClick);
  return () => {
    document.removeEventListener('mouseover', onOver);
    document.removeEventListener('click', onClick);
  };
};
